import { FeatureKey, LucideIconName } from '@bm-js/atlascloud-shared'
import { Icon } from '@bm-js/atlascloud-ui'

type Props = {
  features: string[]
}

const ProfileMenuIcon = ({ features }: Props) => {
  if (!features?.includes(FeatureKey.customerUserLogins)) return null
  return (
    <div>
      <Icon
        name={LucideIconName.CircleUser}
        className='size-5 text-customerInverse'
      />
    </div>
  )
}

export default ProfileMenuIcon
